import styled from "styled-components";

const FilterProductStyle = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");
  
  width: 100%;
  position: relative;

  .search-wrapper {
    position: relative;
    width: 100%;
  }

  /* Main Input Container */
  .search-input-container {
    display: flex;
    align-items: center;
    height: 48px;
    background: white;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.2s ease;

    &:focus-within {
      border-color: #7367f0;
      box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.1);
    }

    &.has-options {
      border-radius: 12px 12px 0 0;
      border-bottom-color: transparent;
    }
  }

  /* Selected Field Badge */
  .selected-field-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    margin-left: 8px;
    background: #7367f0;
    color: white;
    font-size: 11px;
    font-weight: 600;
    border-radius: 6px;
    white-space: nowrap;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /* Search Input */
  .search-input {
    flex: 1;
    height: 100%;
    padding: 0 16px;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif !important;
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    border: none !important;
    outline: none !important;
    background: transparent;

    &::placeholder {
      color: #9ca3af;
    }
  }

  /* Search Button */
  .search-button {
    height: 100%;
    padding: 0 18px;
    font-size: 16px;
    color: white;
    background: #7367f0;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #5a4fcf;
    }

    &:focus {
      outline: none;
    }
  }

  /* Dropdown Options */
  .search-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 2px solid #7367f0;
    border-top: 1px solid #e5e7eb;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    z-index: 1000;
    overflow: hidden;
  }

  .search-options-header {
    padding: 10px 14px;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
  }

  /* Individual Option */
  .search-option {
    display: flex;
    align-items: center;
    padding: 12px 14px;
    cursor: pointer;
    transition: all 0.15s ease;
    border-bottom: 1px solid #f3f4f6;

    &:last-of-type {
      border-bottom: none;
    }

    &:hover {
      background: #f8f7ff;
    }
  }

  .option-icon {
    width: 20px;
    height: 20px;
    color: #7367f0;
    margin-right: 12px;
    font-size: 14px;
  }

  .option-text {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }

  .option-value {
    font-size: 13px;
    font-weight: 600;
    color: #7367f0;
    background: #f0f0ff;
    padding: 4px 10px;
    border-radius: 6px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Hint at bottom */
  .search-hint {
    padding: 10px 14px;
    font-size: 12px;
    color: #9ca3af;
    background: #f9fafb;
    border-top: 1px solid #e5e7eb;
    text-align: center;

    kbd {
      display: inline-block;
      padding: 2px 6px;
      font-size: 11px;
      font-weight: 600;
      color: #374151;
      background: white;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      margin: 0 2px;
    }
  }

  /* Responsive */
  @media (max-width: 576px) {
    .option-value {
      max-width: 100px;
    }

    .search-option {
      padding: 10px 12px;
    }
  }
`;

export default FilterProductStyle;
